import { SortColumn } from './bookings.interface';

export type TableDataProperty = string | number | boolean | object;

export enum TableHeaderId {
  RecordLocatorInfo = 'recordLocatorInfo',
  recordLocatorBlockedPrice = 'recordLocatorBlockedPrice',
  PassengerCount = 'passengerCount',
  Amount = 'amount',
  Status = 'status',
  DepartureDate = 'departureDate',
  ReturnDate = 'returnDate',
  Route = 'route',
  Deadline = 'deadline',
  AvailableCredit = 'availableCredit',
  UseCredit = 'usedCredit'
}

export const headerToSortMap: Partial<Record<TableHeaderId, SortColumn>> = {
  [TableHeaderId.RecordLocatorInfo]: 'RecordLocator',
  [TableHeaderId.DepartureDate]: 'DepartureDate',
  [TableHeaderId.ReturnDate]: 'ReturnDate',
  [TableHeaderId.PassengerCount]: 'PassengerCount',
  [TableHeaderId.Status]: 'Status',
  [TableHeaderId.Amount]: 'Amount',
  [TableHeaderId.AvailableCredit]: 'AvailableCredit',
  [TableHeaderId.UseCredit]: 'UsedCredit'
};

const recordLocatorHeader: Record<string, TableDataProperty> = {
  id: TableHeaderId.RecordLocatorInfo,
  name: 'booking_list_component.bookings_table_headers.record_locator',
  sortable: true,
  emitOnSort: true
};

const recordLocatorBlockedPriceHeader: Record<string, TableDataProperty> = {
  id: TableHeaderId.recordLocatorBlockedPrice,
  name: 'ds.booking_list_component.bookings_table.recordLocatorBlockedPrice',
  sortable: true
};

const passengerCountHeader: Record<string, TableDataProperty> = {
  id: TableHeaderId.PassengerCount,
  name: 'booking_list_component.bookings_table_headers.pax_count',
  sortable: true,
  emitOnSort: true
};

const amountHeader: Record<string, TableDataProperty> = {
  id: TableHeaderId.Amount,
  name: 'booking_list_component.bookings_table_headers.amount',
  sortable: true,
  emitOnSort: true
};

const statusHeader: Record<string, TableDataProperty> = {
  id: TableHeaderId.Status,
  name: 'booking_list_component.bookings_table_headers.status',
  sortable: true,
  emitOnSort: true
};

const departureDateHeader: Record<string, TableDataProperty> = {
  id: TableHeaderId.DepartureDate,
  name: 'booking_list_component.bookings_table_headers.outbound_date',
  sortable: true,
  emitOnSort: true,
  type: 'DATE'
};

const returnDateHeader: Record<string, TableDataProperty> = {
  id: TableHeaderId.ReturnDate,
  name: 'booking_list_component.bookings_table_headers.inbound_date',
  sortable: true,
  emitOnSort: true,
  type: 'DATE'
};

const routeHeader: Record<string, TableDataProperty> = {
  id: TableHeaderId.Route,
  name: 'booking_list_component.bookings_table_headers.route',
  sortable: false
};

const deadlineHeader: Record<string, TableDataProperty> = {
  id: TableHeaderId.Deadline,
  name: 'ds.booking_list_component.bookings_table.deadline',
  sortable: false
};

const availableCreditHeader: Record<string, TableDataProperty> = {
  id: TableHeaderId.AvailableCredit,
  name: 'booking_list_component.bookings_table_headers.credits_flight.availableCredit',
  sortable: true,
  emitOnSort: true
};

const useCreditHeader: Record<string, TableDataProperty> = {
  id: TableHeaderId.UseCredit,
  name: 'booking_list_component.bookings_table_headers.credits_flight.usedCredit',
  sortable: true,
  emitOnSort: true
};

export const defaultHeaders: Record<string, TableDataProperty>[] = [
  recordLocatorHeader,
  routeHeader,
  departureDateHeader,
  returnDateHeader,
  passengerCountHeader,
  statusHeader
];

export const cancelledHeaders: Record<string, TableDataProperty>[] = [
  recordLocatorHeader,
  routeHeader,
  departureDateHeader,
  returnDateHeader,
  passengerCountHeader,
  amountHeader,
  statusHeader
];

export const blockedPriceHeaders: Record<string, TableDataProperty>[] = [
  recordLocatorBlockedPriceHeader,
  routeHeader,
  departureDateHeader,
  returnDateHeader,
  statusHeader,
  deadlineHeader
];

export const creditShellHeaders: Record<string, TableDataProperty>[] = [
  recordLocatorHeader,
  passengerCountHeader,
  availableCreditHeader,
  useCreditHeader,
  statusHeader
];
